import { UI, HStack } from '@genial/components';
import React from 'react';

export interface CustomItemProps {
  label: string;
  value?: React.ReactNode;
}

export const CustomItem: React.FC<CustomItemProps> = ({ label, value }) => {
  return (
    <HStack justifyContent="space-between">
      <UI.Text color="neutral.darkest">{label}</UI.Text>

      {value}
    </HStack>
  );
};
